import Vue from 'vue';
import VueRouter from 'vue-router';

// import store from '@/store/index';
import { publicPath } from '../../vue.config';
import Launcher from '../views/Launcher.vue';
import PageNotFound from '../views/PageNotFound.vue';

import IndexProgramacion from '../views/programacion/Index.vue';
import DashboardProgramacion from '../views/programacion/Dashboard.vue';
import Solicitudes from '../views/investigacion_socioeconomica/Solicitudes.vue';
import Expedientes from '../views/programacion/Expedientes.vue';

import IndexEvaluacionesMedicas from '../views/evaluaciones_medicas/Index.vue';
import PersonalEvaluacionesMedicas from '../views/evaluaciones_medicas/Personal.vue';
import EvaluacionMedica from '../views/evaluaciones_medicas/EvaluacionMedica.vue';
import HistorialClinico from '../views/evaluaciones_medicas/HistorialClinico.vue';

import IndexEvaluacionesPsicologicas from '../views/evaluaciones_psicologicas/Index.vue';
import PersonalEvaluacionesPsicologicas from '../views/evaluaciones_psicologicas/Personal.vue';
import EvaluacionPsicologica from '../views/evaluaciones_psicologicas/EvaluacionPsicologica.vue';

import IndexInvestigacionSocioeconomica from '../views/investigacion_socioeconomica/Index.vue';
import PersonalInvestigacionSocioeconomica from '../views/investigacion_socioeconomica/SolicitudesValidacion.vue';
import DiagnosticoIse from '../views/investigacion_socioeconomica/DiagnosticoIse.vue';
import Validacion from '../views/investigacion_socioeconomica/Validacion.vue';
import Antecedentes from '../views/investigacion_socioeconomica/Antecedentes.vue';
import Ise from '../views/investigacion_socioeconomica/Ise.vue';
import CapturaFoto from '../views/investigacion_socioeconomica/CapturaFoto.vue';
import CapturaHuella from '../views/investigacion_socioeconomica/CapturaHuella.vue';
import CapturaVoz from '../views/investigacion_socioeconomica/CapturaVoz.vue';
import CapturaFirma from '../views/investigacion_socioeconomica/CapturaFirma.vue';
import EvaluacionAntecedentes from '../views/investigacion_socioeconomica/EvaluacionAntecedentes.vue';

import IndexEvaluacionesPoligraficas from '../views/evaluaciones_poligraficas/Index.vue';
import PersonalEvaluacionesPoligraficas from '../views/evaluaciones_poligraficas/Personal.vue';
import EvaluacionPoligrafica from '../views/evaluaciones_poligraficas/Evaluacion.vue';

import IndexIntegración from '../views/integracion/Index.vue';
import PersonalIntegracion from '../views/integracion/Personal.vue';
import EmitirResultados from '../views/integracion/EmitirResultados.vue';
import PreregistrosPage from '../views/investigacion_socioeconomica/PreregistrosPage.vue';
import Login from '../views/Login.vue';
import isUserLoggedIn from '../helpers/isUserLoggedIn';

Vue.use(VueRouter);

function castRouteParams(route) {
  return {
    id: Number(route.params.id),
  };
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/launcher',
    name: 'Launcher',
    component: Launcher,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/programacion',
    name: 'Programación',
    component: IndexProgramacion,
    children: [
      {
        path: 'dashboard',
        component: DashboardProgramacion,
        name: 'Tablero de control',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'programacion.expedientes',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/evaluaciones_psicologicas',
    name: 'Evaluaciones psicológicas',
    component: IndexEvaluacionesPsicologicas,
    children: [
      {
        path: 'personal',
        component: PersonalEvaluacionesPsicologicas,
        name: 'Personal',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'realizar_evaluacion/:idExpediente/:idProgramacion/:idDerivacion',
        component: EvaluacionPsicologica,
        name: 'Evaluación psicológica',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'psicologicas.expedientes',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/investigacion_socioeconomica',
    name: 'Investigación socioeconómica',
    component: IndexInvestigacionSocioeconomica,
    children: [
      {
        path: 'solicitudes',
        component: Solicitudes,
        name: 'Solicitudes',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'validacion',
        component: PersonalInvestigacionSocioeconomica,
        name: 'Personal',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'antecedentes',
        component: Antecedentes,
        name: 'antecedentesIse',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'ise',
        component: Ise,
        name: 'ise',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'expedientes',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'evaluacion_antecedentes/:idExpediente/:idProgramacion/:idDerivacion',
        component: EvaluacionAntecedentes,
        name: 'evaluacionAntecedentes',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'diagnostico/:idExpediente/:idProgramacion/:idDerivacion',
        component: DiagnosticoIse,
        name: 'Expediente personal',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'validacion/:idExpediente/:idProgramacion/:idDerivacion',
        component: Validacion,
        name: 'Validación',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'captura_foto/:idExpediente',
        component: CapturaFoto,
        name: 'capturaFoto',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          return { idExpediente };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'captura_huella/:idExpediente',
        component: CapturaHuella,
        name: 'capturaHuella',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          return { idExpediente };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'captura_voz/:idExpediente',
        component: CapturaVoz,
        name: 'capturaVoz',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          return { idExpediente };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'captura_firma/:idExpediente',
        component: CapturaFirma,
        name: 'capturaFirma',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          return { idExpediente };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'preregistros',
        component: PreregistrosPage,
        name: 'preregistros',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/evaluaciones_medicas',
    name: 'Evaluaciones médicas',
    component: IndexEvaluacionesMedicas,
    children: [
      {
        path: 'personal',
        component: PersonalEvaluacionesMedicas,
        name: 'Personal',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'realizar_evaluacion/:idExpediente/:idProgramacion/:idDerivacion',
        component: EvaluacionMedica,
        name: 'Evaluación médica',
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'historial_clinico/:id',
        component: HistorialClinico,
        name: 'Historial Clínico',
        props: castRouteParams,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'medica.expedientes',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/evaluaciones_poligraficas',
    name: 'Evaluaciones poligráficas',
    component: IndexEvaluacionesPoligraficas,
    children: [
      {
        path: 'personal',
        component: PersonalEvaluacionesPoligraficas,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'realizar_evaluacion/:idExpediente/:idProgramacion/:idDerivacion',
        component: EvaluacionPoligrafica,
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'poligrafica.expedientes',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/integracion',
    name: 'Integración',
    component: IndexIntegración,
    children: [
      {
        path: 'personal',
        component: PersonalIntegracion,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'emitir_resultados/:idExpediente/:idProgramacion/:idDerivacion',
        component: EmitirResultados,
        props: (route) => {
          const idExpediente = Number.parseInt(route.params.idExpediente, 10);
          const idProgramacion = Number.parseInt(route.params.idProgramacion, 10);
          const idDerivacion = Number.parseInt(route.params.idDerivacion, 10);
          return { idExpediente, idProgramacion, idDerivacion };
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'expedientes',
        component: Expedientes,
        name: 'integracion.expedientes',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '*',
    component: PageNotFound,
    name: '404',
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: publicPath,
  routes,
});

router.beforeEach((to, from, next) => {
  const isNextPagePrivate = to.meta.requiresAuth;

  if (isNextPagePrivate && !isUserLoggedIn()) {
    next('/login');
  }

  next();
});

export default router;
